/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SeatHolderActivity } from '@localstack/types';
import type { SortDirection } from '@localstack/types';
import type { UsageInsightSortField } from '@localstack/types';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AnalyticsService {
  /**
   * @param fromDate
   * @param toDate
   * @param searchString
   * @param sortCol
   * @param sortDir
   * @param page
   * @param pageSize
   * @returns SeatHolderActivity
   * @throws ApiError
   */
  public static getUsageInsights(
    fromDate?: string,
    toDate?: string,
    searchString?: string,
    sortCol?: UsageInsightSortField,
    sortDir?: SortDirection,
    page?: number,
    pageSize?: number,
  ): CancelablePromise<Array<SeatHolderActivity>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/usage/my/info',
      query: {
        from_date: fromDate,
        to_date: toDate,
        search_string: searchString,
        sort_col: sortCol,
        sort_dir: sortDir,
        page: page,
        page_size: pageSize,
      },
    });
  }
}
